<template>
  <section class="hero-section" :class="{ 'is-active': isActive }">
    <!-- 배경 이미지 전환 -->
    <div class="hero-bg">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="bg-slide"
        :class="{ active: activeSlide === index }"
      >
        <img :src="slide.image" alt="" />
      </div>
      <div class="hero-overlay"></div>
    </div>

    <!-- 좌측 텍스트 (슬라이드별) -->
    <div class="hero-content" v-if="activeSlide >= 0">
      <transition name="text-fade" mode="out-in">
        <div class="hero-text-wrap" :key="activeSlide">
          <p class="hero-eng">{{ slides[activeSlide].eng }}</p>
          <h2 class="hero-title" v-html="slides[activeSlide].kor"></h2>
        </div>
      </transition>
      <div class="hero-brand">
        <img src="@/assets/logo/logo_white.png" alt="용인남사 대우이안 플렉시티" />
      </div>
    </div>

    <!-- 하단 썸네일 슬라이더 -->
    <div class="thumb-slider" v-if="activeSlide >= 0" @wheel.stop>
      <button class="thumb-arrow prev" @click="prevSlide">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

      <div class="thumb-list">
        <div
          v-for="(slide, index) in slides"
          :key="index"
          class="thumb-item"
          :class="{ active: activeSlide === index }"
          @click="setSlide(index)"
        >
          <img :src="slide.image" :alt="slide.title" />
        </div>
      </div>

      <button class="thumb-arrow next" @click="nextSlide">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>

    <!-- GRAND OPEN 원형 배지 (우측 하단) -->
    <router-link to="/reservation/register" class="go-circle">
      <span class="go-ring"></span>
      <span class="go-line">GRAND</span>
      <span class="go-line">OPEN</span>
    </router-link>
  </section>
</template>

<script>
import heroImg from '@/assets/hero/hero.jpg'
import heroImg2 from '@/assets/hero/hero2.jpg'
import heroImg3 from '@/assets/hero/hero3.png'
import heroImg4 from '@/assets/hero/heo4.jpg'
import heroImg5 from '@/assets/hero/hero5.jpg'
import heroImg6 from '@/assets/hero/hero6.jpg'


export default {
  name: 'HeroSection',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeSlide: -1,
      autoplayTimer: null,
      slides: [
        {
          image: heroImg,
          title: '메인',
          eng: 'Yongin Namsa, The Last Chance',
          kor: '용인 2,108세대 장기전세<br /><strong>내 집 마련</strong>의 마지막 기회'
        },
        {
          image: heroImg3,
          title: '교통',
          eng: 'Future Mobility Hub',
          kor: '고속도로·경강선 연장 등<br /><strong>미래형 광역 교통 허브</strong>'
        },
        {
          image: heroImg4,
          title: '인프라',
          eng: 'Nature Embraces Daily Life',
          kor: '산과 수를 품고 일상과 잇는<br /><strong>프라이빗 에코 리조트</strong>'
        },
        {
          image: heroImg5,
          title: '교육',
          eng: 'One-Stop Edu Town',
          kor: '단지를 품은<br /><strong>원스톱 안심 에듀타운</strong>'
        },
        {
          image: heroImg6,
          title: '생활권',
          eng: 'Double Living Zone',
          kor: '삼성전자·동탄을 누리는<br /><strong>압도적 더블 생활권</strong>'
        },
        {
          image: heroImg2,
          title: '미래가치',
          eng: 'Next Future Value',
          kor: '세계 최대 시스템반도체 국가산단<br /><strong>초근접 미래가치</strong>'
        },
      ]
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.activeSlide = 0
        this.startAutoplay()
      } else {
        this.stopAutoplay()
      }
    }
  },
  beforeUnmount() {
    this.stopAutoplay()
  },
  methods: {
    setSlide(index) {
      this.activeSlide = index
      this.restartAutoplay()
    },
    prevSlide() {
      this.activeSlide = this.activeSlide > 0
        ? this.activeSlide - 1
        : this.slides.length - 1
      this.restartAutoplay()
    },
    nextSlide() {
      this.activeSlide = (this.activeSlide + 1) % this.slides.length
      this.restartAutoplay()
    },
    startAutoplay() {
      this.stopAutoplay()
      this.autoplayTimer = setInterval(() => {
        this.activeSlide = (this.activeSlide + 1) % this.slides.length
      }, 5000)
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    },
    restartAutoplay() {
      this.stopAutoplay()
      this.startAutoplay()
    }
  }
}
</script>

<style scoped>
.hero-section {
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #111;
}

/* ===== 배경 ===== */
.hero-bg {
  position: absolute;
  inset: 0;
}

.bg-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1.2s ease;
}

.bg-slide.active {
  opacity: 1;
}

.bg-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.15);
  transition: transform 6s ease-out;
}

.bg-slide.active img {
  transform: scale(1);
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.15) 0%,
    rgba(0, 0, 0, 0.1) 50%,
    rgba(0, 0, 0, 0.5) 100%
  );
}

/* ===== 좌측 텍스트 ===== */
.hero-content {
  position: absolute;
  left: 80px;
  bottom: 360px;
  z-index: 2;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.hero-section.is-active .hero-content {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.3s;
}

.hero-eng {
  font-family: var(--font-script);
  font-size: 52px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
  letter-spacing: 1px;
  line-height: 1.1;
}

.hero-title {
  font-family: var(--font-pretendard);
  font-size: 38px;
  font-weight: 300;
  color: #fff;
  line-height: 1.5;
  letter-spacing: -0.5px;
}

.hero-title :deep(strong) {
  font-weight: 800;
  color: #fff;
}

.hero-title :deep(small) {
  font-size: 0.6em;
  font-weight: 400;
  opacity: 0.75;
  margin: 0 2px;
}

/* ===== GRAND OPEN 원형 배지 (우측 하단) ===== */
.go-circle {
  position: absolute;
  right: 48px;
  bottom: 40px;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  z-index: 5;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.go-circle:hover {
  transform: scale(1.05);
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.24);
}

.go-ring {
  position: absolute;
  inset: -14px;
  border-radius: 50%;
  border: 1px dashed rgba(255, 255, 255, 0.85);
  animation: go-spin 22s linear infinite;
  pointer-events: none;
}

.go-line {
  font-family: var(--font-paperlogy);
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 1px;
  color: var(--ecofore-accent);
  line-height: 1.1;
  position: relative;
  z-index: 1;
}

@keyframes go-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@media (max-width: 1024px) {
  .go-circle {
    right: 32px;
    bottom: 32px;
    width: 96px;
    height: 96px;
  }
  .go-line {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .go-circle {
    right: 20px;
    bottom: 110px;
    width: 80px;
    height: 80px;
  }
  .go-ring {
    inset: -10px;
  }
  .go-line {
    font-size: 13px;
    letter-spacing: 0.5px;
  }
}

@media (max-width: 480px) {
  .go-circle {
    width: 70px;
    height: 70px;
    bottom: 100px;
    right: 16px;
  }
  .go-line {
    font-size: 11px;
  }
}

.hero-brand {
  margin-top: 30px;
  opacity: 0;
  transform: translateY(15px);
  transition: all 0.7s ease;
}

.hero-section.is-active .hero-brand {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.6s;
}

.hero-brand img {
  height: 80px;
  width: auto;
}

/* 텍스트 트랜지션 */
.text-fade-enter-active {
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.text-fade-leave-active {
  transition: all 0.3s ease;
}

.text-fade-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.text-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ===== 하단 썸네일 슬라이더 ===== */
.thumb-slider {
  position: absolute;
  bottom: 20px;
  left: 80px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 0;
}

.thumb-list {
  display: flex;
  gap: 6px;
}

.thumb-item {
  width: 160px;
  height: 95px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.4s ease;
}

.thumb-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(1) brightness(0.5);
  transition: all 0.5s ease;
}

.thumb-item.active {
  border-color: rgba(255, 255, 255, 0.8);
}

.thumb-item.active img {
  filter: none;
}

.thumb-item:hover:not(.active) img {
  filter: grayscale(0.3) brightness(0.7);
}

/* 화살표 */
.thumb-arrow {
  width: 36px;
  height: 36px;
  background: none;
  border: 1.5px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.thumb-arrow.prev {
  margin-right: 12px;
}

.thumb-arrow.next {
  margin-left: 12px;
}

.thumb-arrow:hover {
  border-color: #fff;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

/* ===== 반응형 ===== */

/* Large desktop → Small desktop */
@media (max-width: 1200px) {
  .hero-content { left: 60px; bottom: 260px; }
  .hero-eng { font-size: 38px; }
  .hero-title { font-size: 32px; }
  .thumb-slider { left: 60px; }
  .thumb-item { width: 140px; height: 85px; }
}

/* Tablet landscape */
@media (max-width: 1024px) {
  .hero-content {
    left: 50px;
    bottom: 240px;
  }
  .hero-eng {
    font-size: 34px;
    margin-bottom: 16px;
  }
  .hero-title {
    font-size: 30px;
  }
  .hero-brand {
    margin-top: 24px;
  }
  .hero-brand img {
    height: 68px;
  }
  .thumb-slider {
    left: 50px;
  }
  .thumb-item {
    width: 130px;
    height: 80px;
  }
}

/* Tablet portrait / Large mobile */
@media (max-width: 900px) {
  .hero-content {
    left: 30px;
    bottom: 220px;
  }
  .hero-eng {
    font-size: 28px;
  }
  .hero-title {
    font-size: 26px;
  }
  .hero-brand img {
    height: 60px;
  }
  .thumb-slider {
    left: 20px;
    bottom: 16px;
  }
  .thumb-item {
    width: 110px;
    height: 68px;
  }
  .thumb-arrow {
    width: 30px;
    height: 30px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .hero-section {
    height: 100vh;
    height: 100dvh; /* dynamic viewport height for mobile browsers */
  }

  .hero-overlay {
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.15) 40%,
      rgba(0, 0, 0, 0.55) 100%
    );
  }

  .hero-content {
    left: 24px;
    right: 24px;
    bottom: 200px;
    text-align: left;
  }

  .hero-content,
  .hero-section.is-active .hero-content {
    transform: translateY(0);
  }

  .hero-section.is-active .hero-content {
    opacity: 1;
  }

  .hero-eng {
    font-size: 22px;
    margin-bottom: 12px;
    letter-spacing: 0.5px;
    line-height: 1.2;
  }

  .hero-title {
    font-size: 28px;
    line-height: 1.45;
    letter-spacing: -0.3px;
    word-break: keep-all;
  }

  .hero-brand {
    margin-top: 20px;
  }

  .hero-brand img {
    height: 52px;
  }

  /* Smaller animation translateY on mobile */
  .text-fade-enter-from {
    transform: translateY(12px);
  }
  .text-fade-leave-to {
    transform: translateY(-6px);
  }

  /* Thumbnail slider - mobile layout */
  .thumb-slider {
    left: 16px;
    right: 16px;
    bottom: 16px;
    justify-content: center;
  }

  .thumb-list {
    gap: 4px;
  }

  .thumb-item {
    width: 90px;
    height: 56px;
    border-width: 1.5px;
  }

  .thumb-arrow {
    width: 28px;
    height: 28px;
  }

  .thumb-arrow.prev {
    margin-right: 8px;
  }

  .thumb-arrow.next {
    margin-left: 8px;
  }

  .thumb-arrow svg {
    width: 16px;
    height: 16px;
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .hero-content {
    left: 20px;
    right: 20px;
    bottom: 140px;
  }

  .hero-eng {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .hero-title {
    font-size: 24px;
    line-height: 1.4;
  }

  .hero-brand {
    margin-top: 16px;
  }

  .hero-brand img {
    height: 44px;
  }

  .thumb-slider {
    left: 12px;
    right: 12px;
    bottom: 12px;
  }

  .thumb-item {
    width: 72px;
    height: 45px;
  }

  .thumb-arrow {
    width: 26px;
    height: 26px;
  }

  .thumb-arrow.prev {
    margin-right: 6px;
  }

  .thumb-arrow.next {
    margin-left: 6px;
  }
}

/* Landscape orientation on mobile - prevent content overflow */
@media (max-width: 768px) and (orientation: landscape) {
  .hero-content {
    bottom: 100px;
  }

  .hero-eng {
    font-size: 18px;
    margin-bottom: 8px;
  }

  .hero-title {
    font-size: 22px;
    line-height: 1.35;
  }

  .hero-brand {
    margin-top: 12px;
  }

  .hero-brand img {
    height: 40px;
  }

  .thumb-item {
    width: 80px;
    height: 48px;
  }
}
</style>
